import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const WindscreenWiperIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12.3 19.66L13.02 16.78C12.68 16.76 12.34 16.76 12 16.76C9.92 16.76 7.54 17.12 5.42 17.98L2 6.9C4.98 5.3 8.36 4.54 12 4.54C15.64 4.54 19.02 5.3 22 6.9L18.58 17.98C17.38 17.5 16.1 17.16 14.84 16.98L14.04 20.06L12.3 19.66ZM12 6.28C9.2 6.28 6.58 6.82 4.24 7.98L6.62 15.74C8.38 15.18 10.38 14.92 12 14.92C12.46 14.92 12.96 14.94 13.48 14.98L15.58 6.6C14.44 6.38 13.24 6.28 12 6.28ZM15.3 15.22C16 15.36 16.7 15.52 17.38 15.74L19.76 7.98C19.02 7.6 18.22 7.3 17.42 7.04L15.3 15.22Z" />
    </SvgIcon>
  );
});
